import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledEmptyContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 489px;

	${Text} {
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.5;
	}
`;

export { StyledEmptyContainer };
